
<template>
    <div>请选择皮肤颜色</div>
</template>
<script>
export default {
    
    name: 'themePicker',//这个LoginName最好和引入的vue的LoginName相同
}
</script>


// WEBPACK FOOTER //
// src/components/themePicker.vue